import { MainColor } from '../../../palette';

export const getProfileButtonThemeConfig = () => {
  return {
    states: {
      hover: {
        color: 'navy70' as MainColor,
        backgroundColor: 'navy10' as MainColor,
      },
      active: {
        color: 'navy60' as MainColor,
        backgroundColor: 'navy10' as MainColor,
      },
      focusVisible: {
        color: 'navy60' as MainColor,
        backgroundColor: 'navy90' as MainColor,
      },
      focus: {
        color: 'navy80' as MainColor,
        outlineColor: 'navy40' as MainColor,
      },
    },
    avatarBackgrounds: [
      {
        color: 'violet60' as MainColor,
        background: 'violet20' as MainColor,
        border: 'violet30' as MainColor,
      },
      {
        color: 'rose60' as MainColor,
        background: 'rose20' as MainColor,
        border: 'rose30' as MainColor,
      },
      {
        color: 'orange60' as MainColor,
        background: 'orange20' as MainColor,
        border: 'orange30' as MainColor,
      },
      {
        color: 'brown60' as MainColor,
        background: 'brown20' as MainColor,
        border: 'brown30' as MainColor,
      },
      {
        color: 'yellow60' as MainColor,
        background: 'yellow20' as MainColor,
        border: 'yellow30' as MainColor,
      },
      {
        color: 'green60' as MainColor,
        background: 'green20' as MainColor,
        border: 'green30' as MainColor,
      },
    ],
  };
};
